import {
	ExtraId,
	IExtra,
} from '../../../../../domain/ancillary/domain/models/IExtra';
import {
	ExtraVariantId,
	IExtraVariant,
} from '../../../../../domain/ancillary/domain/models/IExtraVariant';
import { IExtraLevel, IExtraVariantLevel } from '../../nested-input';
import { IOption, IOptionGroup } from '../../option';

export function adaptExtraToOptionGroup(
	{
		id,
		name,
		headline,
		description,
		hasMutuallyExclusiveVariants,
		variants,
	}: IExtra,
	nestedInputLevel: IExtraLevel,
): IOptionGroup<ExtraId, ExtraVariantId> {
	const options = variants.map((variant, extraVariantIndex) =>
		adaptExtraVariantToOption(variant, {
			...nestedInputLevel,
			extraVariantIndex,
		}),
	);

	return {
		id,
		title: name,
		headline,
		moreInformation: description,
		hasMutuallyExclusiveOptions: hasMutuallyExclusiveVariants,
		options,
		nestedInputLevel,
	};
}

function adaptExtraVariantToOption(
	{ id, name, price }: IExtraVariant,
	nestedInputLevel: IExtraVariantLevel,
): IOption<ExtraVariantId> {
	return {
		id,
		label: name,
		nestedInputLevel,
		price,
	};
}
